import React from 'react';
import PropTypes from 'prop-types';
import {AdvancedImage} from '@cloudinary/react';

import {constructPlugins} from './helpers';

const CloudinaryImage = ({
  image,
  useLazyLoad,
  lazyLoadThreshold,
  lazyLoadMargin,
  responsiveSteps,
  usePlaceholder,
  placeholderMode,
  useAccessibility,
  accessibilityMode,
  plugins: extraPlugins,
  ...props
}) => {
  const plugins = constructPlugins({
    useLazyLoad,
    lazyLoadThreshold,
    lazyLoadMargin,
    responsiveSteps,
    usePlaceholder,
    placeholderMode,
    useAccessibility,
    accessibilityMode,
    extraPlugins,
  });

  return <AdvancedImage {...props} cldImg={image} plugins={plugins} />;
};

CloudinaryImage.propTypes = {
  /** The CloudinaryImage object to paint */
  image: PropTypes.object.isRequired,

  /** Adds lazyload plugin */
  useLazyLoad: PropTypes.bool,

  /** Lazyload plugin threshold */
  lazyLoadThreshold: PropTypes.number,

  /** Lazyload plugin rootMargin */
  lazyLoadMargin: PropTypes.string,

  /** If present, adds responsive plugin */
  responsiveSteps: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),

  /** Adds placeholder plugin */
  usePlaceholder: PropTypes.bool,

  /** The placeholder plugin mode. If none given, it will default to `blur` */
  placeholderMode: PropTypes.oneOf(['blur', 'pixelate', 'vectorize', 'predominant-color']),

  /** Adds accessibility plugin */
  useAccessibility: PropTypes.bool,

  /** The accessibility plugin mode. If none given, it will default to `darkmode` */
  accessibilityMode: PropTypes.oneOf(['monochrome', 'darkmode', 'brightmode', 'colorblind']),

  /** Any extra plugin that should be added to the list */
  plugins: PropTypes.array,
};

export default CloudinaryImage;
